// extracted by mini-css-extract-plugin
export default {"renewDialogContent":"styles_renewDialogContent__Kin1Z","renewDialogButtons":"styles_renewDialogButtons__edWTX"};